import React from "react";

function Separator() {
  return <div className="bg-gray-200 h-1 w-[150px] my-8 rounded-xl" />;
}

export default Separator;
